'use strict';

var zelloOptions = {
    action: false,

    /** Sign in */
    signInGetTokenApiUrl: 'user/gettoken',
    signInApiUrl: 'user/login',
    signInCompleteRedirect: 'user/home',
    signInForm: '#sing_in_form',
    signInUsernameField: 'input[name="username"]',
    signInPasswordField: 'input[name="password"]',
    signInCaptchaItem: '#security-login-captcha',

    /** Forgot password */
    forgotPasswordApiUrl: 'forgot_password/send',
    forgotPasswordStep_1: '#reset_password_1',
    forgotPasswordStep_2: '#reset_password_2',
    forgotPasswordBackToStep_1: '#reset_password__back_to_step_1',
    forgotPasswordForm: '#forgot_password',
    forgotPasswordEmailField: 'input[name="email"]'
};

/**
 * Constructor
 * @param wrapper
 * @param settings
 * @private
 */
var _zelloAccountConnection = function (wrapper, settings) {
    this.wrapper = jQuery(wrapper);
    this.settings = settings;
    this.productionDomain = __jsVars.url.production;
    this._init();
};

/**
 * Init action
 * @private
 */
_zelloAccountConnection.prototype._init = function () {
    var _self = this;

    /** Run by connection 'action' */
    switch (_self.settings.action){
        case 'forgot_password':
            _self._forgotPassword();
            break;
        case 'sign_in':
            _self._signIn();
            break;
        default:
            console.warn('Parameter "action" must be defined');
    }
};

/**
 * URL builder to production connection
 * @param pathname
 * @returns {*}
 * @private
 */
_zelloAccountConnection.prototype._getProductionUrl = function (pathname) {
    return this.productionDomain + pathname;
};

/**
 * Forgot password action
 * @private
 */
_zelloAccountConnection.prototype._forgotPassword = function () {
    var _self = this;

    /** On email keyup */
    _self.wrapper.find(_self.settings.forgotPasswordForm).on('keyup', _self.settings.forgotPasswordEmailField, function () {
        var form = jQuery(this).closest(_self.settings.forgotPasswordForm),
            input = form.find(_self.settings.forgotPasswordEmailField),
            email = input.val();

        if (form.is('.is-submitted')) {
            input.removeClass('form-control-error').next('.form-control-error-message').remove();

            if (!_self._validator.required(email)){
                input.addClass('form-control-error').after('<div class="form-control-error-message">Email is required!</div>');
                return false;
            }

            if (!_self._validator.email(email)){
                input.addClass('form-control-error').after('<div class="form-control-error-message">Email is not valid!</div>');
                return false;
            }
        }
    });

    /** On form submit */
    _self.wrapper.on('submit', _self.settings.forgotPasswordForm, function (event) {
        event.preventDefault();
        var form = jQuery(this),
            input = form.find(_self.settings.forgotPasswordEmailField),
            button = form.find('button[type="submit"]'),
            email = input.val();

        form.addClass('is-submitted');
        input.removeClass('form-control-error').next('.form-control-error-message').remove();

        /** If has email */
        if (!_self._validator.required(email)){
            input.addClass('form-control-error').after('<div class="form-control-error-message">Email is required!</div>');
            return false;
        }

        /** If email is required*/
        if (!_self._validator.email(email)){
            input.addClass('form-control-error').after('<div class="form-control-error-message">Email is not valid!</div>');
            return false;
        }

        /** Add preloder to button */
        buttonAddPreloader(button);

        /** Remove error message */
        form.find('.screen-reader-response').remove();

        /** Send email to API */
        jQuery.post(_self._getProductionUrl(_self.settings.forgotPasswordApiUrl), {
            email: email
        }).done(function (response) {
            var forgotPasswordStatus = JSON.parse(response);

            /** If status is "OK" -> redirect on next step of reset password */
            if (parseInt(forgotPasswordStatus.code) === 200){
                _self.wrapper.find(_self.settings.forgotPasswordStep_1).addClass('hidden');
                _self.wrapper.find(_self.settings.forgotPasswordStep_2).removeClass('hidden');
            } else {
                /** Add message box */
                form.append('<div class="screen-reader-response">' + forgotPasswordStatus.status + '</div>');
            }
        }).fail(function(error) {
            console.log(error);
            var forgotPasswordStatus = JSON.parse(error.responseText);
            if (typeof forgotPasswordStatus.status !== "undefined"){
                form.append('<div class="screen-reader-response">' + forgotPasswordStatus.status + '</div>');
            }
        }).always(function () {
            buttonRemovePreloader(button);
        });
        return false;
    });

    /** Back to step 1  */
    _self.wrapper.on('click', _self.settings.forgotPasswordBackToStep_1, function (e) {
        e.preventDefault();
        _self.wrapper.find(_self.settings.forgotPasswordStep_1).removeClass('hidden');
        _self.wrapper.find(_self.settings.forgotPasswordStep_2).addClass('hidden');
    });
};

/**
 * Sign In action
 * @private
 */
_zelloAccountConnection.prototype._signIn = function () {
    var _self = this;

    /** On username keyup */
    _self.wrapper.find(_self.settings.signInForm).on('keyup', _self.settings.signInUsernameField, function () {
        var form = jQuery(this).closest(_self.settings.signInForm),
            inputUsername = form.find(_self.settings.signInUsernameField),
            username = inputUsername.val();

        if (form.is('.is-submitted')) {
            inputUsername.removeClass('form-control-error').next('.form-control-error-message').remove();

            if (!_self._validator.required(username)) {
                inputUsername.addClass('form-control-error').after('<div class="form-control-error-message">Username is required!</div>');
                return false;
            }
        }
    });

    /** On password keyup */
    _self.wrapper.find(_self.settings.signInForm).on('keyup', _self.settings.signInPasswordField, function () {
        var form = jQuery(this).closest(_self.settings.signInForm),
            inputPassword = form.find(_self.settings.signInPasswordField),
            password = inputPassword.val();

        if (form.is('.is-submitted')) {
            inputPassword.removeClass('form-control-error').next('.form-control-error-message').remove();

            if (!_self._validator.required(password)){
                inputPassword.addClass('form-control-error').after('<div class="form-control-error-message">Password is required!</div>');
                return false;
            }
        }
    });

    /** On form submit */
    _self.wrapper.on('submit', _self.settings.signInForm, function (event) {
        event.preventDefault();
        var form = jQuery(this),
            inputUsername = form.find(_self.settings.signInUsernameField),
            inputPassword = form.find(_self.settings.signInPasswordField),
            button = form.find('button[type="submit"]'),
            username = inputUsername.val(),
            password = inputPassword.val(),
            recaptcha_response_field = form.find('[name=g-recaptcha-response]').val(),
            recaptcha_challenge_field = null;

        form.addClass('is-submitted');

        inputUsername.removeClass('form-control-error').next('.form-control-error-message').remove();
        inputPassword.removeClass('form-control-error').next('.form-control-error-message').remove();

        /** If has username */
        if (!_self._validator.required(username)){
            inputUsername.addClass('form-control-error').after('<div class="form-control-error-message">Username is required!</div>');
            return false;
        }

        /** If has password */
        if (!_self._validator.required(password)){
            inputPassword.addClass('form-control-error').after('<div class="form-control-error-message">Password is required!</div>');
            return false;
        }

        /** Remove error message */
        form.find('.screen-reader-response').remove();

        /** Add preloader to button */
        buttonAddPreloader(button);
        /** Get needed properties to sign in action */
        jQuery.get(_self._getProductionUrl(_self.settings.signInGetTokenApiUrl)).done(function (response) {
            var properties = JSON.parse(response);

            /** If status is "OK" */
            if (properties.status.toUpperCase() === "OK"){
                /** Send parameters to API */
                jQuery.post(_self._getProductionUrl(_self.settings.signInApiUrl) + '?sid=' + properties.sid, {
                    username: username,
                    password: hex_md5(hex_md5(password) + properties.token + properties.nonce),
                    nonce: properties.nonce,
                    recaptcha_response_field: recaptcha_response_field,
                    recaptcha_challenge_field: recaptcha_challenge_field
                }).done(function (response) {
                    var signInStatus = JSON.parse(response);

                    /** If status is "OK" */
                    if (parseInt(signInStatus.code) === 200 && signInStatus.status.toUpperCase() === "OK") {
                        wpCookies.set('username', username, '', '/', 'zello.com', userSettings.secure);
                        wpCookies.set('username', username, '', '/', 'www.zello.com', userSettings.secure);

                        /** If redirect url has in response, else redirect to step 2 */
                        if (typeof signInStatus.redirect !== "undefined") {
                            document.location.href = _self._getProductionUrl(signInStatus.redirect);
                        } else {
                            document.location.href = _self._getProductionUrl(_self.settings.signInCompleteRedirect);
                        }
                    } else {
                        /** Add message box */
                        form.append('<div class="screen-reader-response">' + signInStatus.status + '</div>');

                        if (parseInt(signInStatus.failedLoginAttemptsCount) >= 3) {
                            jQuery('#security-login-captcha').removeClass('hidden');
                            grecaptcha.reset();
                        }
                    }
                }).fail(function(error) {
                    console.log(error);
                }).always(function () {
                    buttonRemovePreloader(button);
                });
            }
        }).fail(function(error) {
            console.log(error);
            buttonRemovePreloader(button);
        });
        return false;
    });
};

/**
 * Validator
 * @type {{required: _zelloAccountConnection._validator.required, email: _zelloAccountConnection._validator.email}}
 * @private
 */
_zelloAccountConnection.prototype._validator = {
    required: function (value) {
        return typeof value !== "undefined" && value.trim() !== '';
    },
    email: function (value) {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
    }
};

/**
 * Init Service
 * @param selector
 * @param options
 * @returns {*}
 */
var zelloAccountConnection = function (selector, options) {
    try {
        var service,
            sections = document.querySelectorAll(selector);
        if (1 === sections.length)
            service = new _zelloAccountConnection(sections, jQuery.extend({}, zelloOptions, options));
        else if (sections.length > 1) {
            service = {};
            for (var i = 0; i < sections.length; i++)
                service[i] = new _zelloAccountConnection(service[i], jQuery.extend({}, zelloOptions, options))
        }
        return service
    } catch (error) {
        throw error
    }
};